import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithTheBoyz = () => {
  return (
    <KpopStudyPageTemplate
      groupName="THE BOYZ"
      groupNameDisplay="THE BOYZ"
      fandomName="THE Bs"
      seoTitle="Study With THE BOYZ - THE BOYZ Study Rooms"
      seoDescription="Study with THE BOYZ fans worldwide. Join THE Bs in virtual study rooms with THE BOYZ playlists."
      seoKeywords="study with the boyz, the boyz study room, the b study, kpop study room"
      canonicalUrl="/study-with-the-boyz/"
      heroDescription="Join a global community of THE Bs who combine their passion for THE BOYZ with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://theboyz.io/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">THE BOYZ</a> is a South Korean boy band formed by IST Entertainment in 2017. Known for their impressive performances and winning Road to Kingdom.
          </p>
          <p>
            THE BOYZ's fanbase, known as THE B, supports the group with unwavering dedication. Follow them on <a href="https://www.instagram.com/the_boyz_official/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/IST_THEBOYZ" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@THEBOYZ" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          THE BOYZ fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/6LOYk1bxhRmzIthvDstxop" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">THE BOYZ's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "THE BOYZ Study Playlists", desc: "Curated playlists featuring THE BOYZ's music to keep you motivated." },
        { title: "Connect with THE B", desc: "Meet fellow THE Bs from around the world who share your passion." },
        { title: "Performance-Ready Rooms", desc: "Study rooms with THE BOYZ-inspired energy and excellence." },
        { title: "Kingdom Sessions", desc: "Study like royalty with other THE Bs worldwide." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of THE BOYZ can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://theboyz.io/" },
        { name: "YouTube", url: "https://www.youtube.com/@THEBOYZ" },
        { name: "Instagram", url: "https://www.instagram.com/the_boyz_official/" },
        { name: "X (Twitter)", url: "https://twitter.com/IST_THEBOYZ" },
        { name: "Spotify", url: "https://open.spotify.com/artist/6LOYk1bxhRmzIthvDstxop" },
      ]}
      youtubeVideos={[
        { id: "R_W5lzaqQRg", title: "THE BOYZ - MAVERICK M/V" },
        { id: "6Mz4NF0fCPQ", title: "THE BOYZ - ROAR M/V" },
        { id: "sLfPVdYQkkU", title: "THE BOYZ - Nectar M/V" },
        { id: "YhQqy4N0wV8", title: "THE BOYZ - REVEAL M/V" },
        { id: "S5RI7DXIvyQ", title: "THE BOYZ - The Stealer M/V" },
        { id: "rE9zsLsxuNc", title: "THE BOYZ - LIP GLOSS M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@THEBOYZ"
      youtubeChannelName="THE BOYZ"
    />
  );
};

export default StudyWithTheBoyz;
